// @ts-nocheck
import React from 'react';
import TuiEditorWrapped from '../TuiEditorWrapped';

// Vidende (Webpack SPA) layer — the editor is loaded statically. No Next.
// Pairs with packages/components/portal/TuiEditor.tsx (the next/dynamic variant).
// See ADR 0003 (shared package = core + thin per-app layers).
const TuiEditor = React.forwardRef((props, ref) => (
    <TuiEditorWrapped {...props} forwardedRef={ref} />
));

export default TuiEditor;
